import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import type {
  ScholarshipDashboardTestSummary,
  ScholarshipTestResultSummary,
} from "@/store/types/ScholarshipTestType";

export const getScholarshipDashboardTest = createAsyncThunk<
  ScholarshipDashboardTestSummary | null,
  string
>("scholarship/getScholarshipDashboardTest", async (userId, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/tests/getTest/${userId}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getScholarshipDashboardResult = createAsyncThunk<
  ScholarshipTestResultSummary | null,
  string
>("scholarship/getScholarshipDashboardResult", async (testId, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/tests/result/${testId}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
